import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiBell, FiX, FiCheck, FiTrash2 } from "react-icons/fi";
import "./css/NotificationBell.css";

function timeAgo(date) {
  const diff = Math.floor((Date.now() - new Date(date)) / 1000);
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export default function NotificationBell({
  notifications,
  unreadCount,
  markAllRead,
  markRead,
  clearAll,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [open]);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const handleNotifClick = (notif) => {
    markRead(notif.id);
    setOpen(false);
    if (notif.path) navigate(notif.path);
  };

  return (
    <div className="notif-bell-wrapper" ref={ref}>
      {/* Bell Button */}
      <button
        className={`notif-bell-btn ${unreadCount > 0 ? "has-unread" : ""}`}
        onClick={handleOpen}
        aria-label="Notifications"
      >
        <FiBell size={18} />
        {unreadCount > 0 && (
          <span className="notif-bell-badge">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown */}
      {open && (
        <div className="notif-dropdown">
          {/* Header */}
          <div className="notif-dropdown-header">
            <span className="notif-dropdown-title">
              Notifications
              {unreadCount > 0 && (
                <span className="notif-header-count">{unreadCount} new</span>
              )}
            </span>
            <div className="notif-header-actions">
              {unreadCount > 0 && (
                <button
                  className="notif-action-btn"
                  onClick={markAllRead}
                  title="Mark all read"
                >
                  <FiCheck size={13} />
                </button>
              )}
              {notifications.length > 0 && (
                <button
                  className="notif-action-btn notif-action-danger"
                  onClick={clearAll}
                  title="Clear all"
                >
                  <FiTrash2 size={13} />
                </button>
              )}
              <button
                className="notif-action-btn"
                onClick={() => setOpen(false)}
              >
                <FiX size={13} />
              </button>
            </div>
          </div>

          {/* List */}
          <div className="notif-list">
            {notifications.length === 0 ? (
              <div className="notif-empty">
                <FiBell size={28} />
                <p>No notifications</p>
              </div>
            ) : (
              notifications.map((notif) => (
                <div
                  key={notif.id}
                  className={`notif-item ${!notif.read ? "notif-item-unread" : ""}`}
                  onClick={() => handleNotifClick(notif)}
                >
                  {/* Color dot + icon */}
                  <div
                    className="notif-item-icon"
                    style={{ background: notif.bg, color: notif.color }}
                  >
                    {notif.icon}
                  </div>
                  {/* Content */}
                  <div className="notif-item-content">
                    <div className="notif-item-label" style={{ color: notif.color }}>
                      {notif.label}
                    </div>
                    <div className="notif-item-msg">{notif.message}</div>
                    <div className="notif-item-time">{timeAgo(notif.timestamp)}</div>
                  </div>
                  {/* Unread dot */}
                  {!notif.read && (
                    <div
                      className="notif-unread-dot"
                      style={{ background: notif.color }}
                    />
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}